import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
export default function LosseHeadScripts(props) {
    // gtm
    useEffect(() => {
        var _a, _b;
        if (!((_a = props.gtm) === null || _a === void 0 ? void 0 : _a.id))
            return;
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('async', 'true');
        script.setAttribute('defer', 'true');
        script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${(_b = props.gtm) === null || _b === void 0 ? void 0 : _b.id}');
    `;
        const head = document.querySelector('html > head');
        if (!head)
            return;
        head.append(script);
    }, []);
    // cookie bot
    useEffect(() => {
        var _a;
        if (!((_a = props.cb) === null || _a === void 0 ? void 0 : _a.id))
            return;
        const script = document.createElement('script');
        script.setAttribute('id', 'Cookiebot');
        script.setAttribute('src', 'https://consent.cookiebot.com/uc.js');
        script.setAttribute('data-cbid', props.cb.id);
        script.setAttribute('type', 'text/javascript');
        if (!props.cb.blockingmode)
            script.setAttribute('async', 'true');
        if (props.cb.blockingmode)
            script.setAttribute('data-blockingmode', props.cb.blockingmode);
        const head = document.querySelector('html > head');
        if (!head)
            return;
        head.append(script);
        return;
    }, []);
    return _jsx(_Fragment, {});
}
